import { render, staticRenderFns } from "./LeadDistributionView.vue?vue&type=template&id=959a39be&scoped=true&"
import script from "./LeadDistributionView.vue?vue&type=script&lang=js&"
export * from "./LeadDistributionView.vue?vue&type=script&lang=js&"
import style0 from "./LeadDistributionView.vue?vue&type=style&index=0&id=959a39be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959a39be",
  null
  
)

export default component.exports